// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.secondary[data-v-8598019c]:before {
  color: #bbbbbb;
}
th .btn[data-v-8598019c] {
  font-weight: inherit;
}
.icon-sortable[data-v-8598019c]:before {
  color: #bbbbbb;
}
`, "",{"version":3,"sources":["webpack://./public/pages/elementTemplates/DataTableDef.3.vue","webpack://./../DataTableDef.3.vue"],"names":[],"mappings":"AACA;EACI,cAAA;ACAJ;ADEA;EACI,oBAAA;ACAJ;ADEA;EACI,cAAA;ACAJ","sourcesContent":["\n.secondary:before {\n    color: #bbbbbb;\n}\nth .btn {\n    font-weight: inherit;\n}\n.icon-sortable:before {\n    color: #bbbbbb;\n}\n",".secondary:before {\n  color: #bbbbbb;\n}\nth .btn {\n  font-weight: inherit;\n}\n.icon-sortable:before {\n  color: #bbbbbb;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
